module.exports = __webpack_public_path__ + "img/3.9d8e378e.jpg";